/* CUSTOM.JS */

/* Move product badges on product cards */
function moveProductBadges() {
  document.querySelectorAll(".product-card-wrapper").forEach(function(elem) {
    const productTags = elem.querySelector(".product__tags");
    if (productTags) {
      elem.querySelector(".product-card__image-wrapper").prepend(productTags);
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  /* Move Judge.me reviews */
  const reviewPanel = document.getElementById("reviewPanel");

  if (reviewPanel) {
    const judgeMeWidget = document.getElementById("judgeme_product_reviews");
    reviewPanel.querySelector(".product-single_fit-notes .rte").append(judgeMeWidget);
    const reviewPanelDetail = reviewPanel.querySelector(".product__collapsible-details");
    let i = 10;

    const interval = setInterval(function() {
      reviewPanelDetail.style.removeProperty('--expanded');
      reviewPanelDetail.open = true;
      const rectOpen = reviewPanelDetail.getBoundingClientRect();
      reviewPanelDetail.style.setProperty('--expanded', `${rectOpen.height}px`);
      reviewPanelDetail.open = false;
      i--;

      if (i === 0) clearInterval(interval);
    }, 100);
  }
  moveProductBadges();
});

document.addEventListener("recommendations-loaded", moveProductBadges);